import React from 'react';

import { InboxConsumer } from 'src/components/inbox';
import {
  ApproveVerificationRequestByEmployeeModal,
  DeclineVerificationRequestByEmployeeModal,
} from 'src/modals/verificationRequest';

export const InboxPageConsumer: React.FC = () => {
  return (
    <React.Fragment>
      <InboxConsumer />
      <ApproveVerificationRequestByEmployeeModal />
      <DeclineVerificationRequestByEmployeeModal />
    </React.Fragment>
  );
};
